import axios from "axios";
import { getStoredAccessToken } from "@/components/auth/tokenManager";

import { appConfig } from "@/config/app";

const api = axios.create({
    baseURL: appConfig.backendUrl,
});

api.interceptors.request.use(async (config) => {

    const token = await getStoredAccessToken();
  

    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    /*
    console.log("token")
    console.log(token)

    console.groupCollapsed(
        `[API Request] ${config.method?.toUpperCase()} ${config.baseURL}${config.url}`
    );

    console.log("token:", token);
    console.log("headers before:", config.headers);

    console.trace("[API Request Stacktrace]");

    console.groupEnd();
    */

    config.headers.set('Content-Type', 'application/json');

    //config.headers.set("Access-Control-Allow-Origin", "*")
    //config.headers.set("Access-Control-Allow-Methods", "GET,PUT,POST,DELETE,PATCH,OPTIONS")

    return config;
});

export default api;
